import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const SnapshotsIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5 2C3.34315 2 2 3.34315 2 5V15C2 16.6569 3.34315 18 5 18H15C16.6569 18 18 16.6569 18 15V5C18 3.34315 16.6569 2 15 2H5ZM4 5C4 4.44772 4.44772 4 5 4H15C15.5523 4 16 4.44772 16 5V12H4V5ZM4 14H16V15C16 15.5523 15.5523 16 15 16H5C4.44772 16 4 15.5523 4 15V14ZM22 9C22 8.44772 21.5523 8 21 8C20.4477 8 20 8.44772 20 9V17C20 18.6569 18.6569 20 17 20H9C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22H17C19.7614 22 22 19.7614 22 17V9Z"
    fill="currentColor"
  />,
  "SnapshotsIcon"
);
